import { render } from "./BusinessBanner.vue?vue&type=template&id=23d1a8f0&scoped=true"
import script from "./BusinessBanner.vue?vue&type=script&lang=js"
export * from "./BusinessBanner.vue?vue&type=script&lang=js"

import "./BusinessBanner.vue?vue&type=style&index=0&id=23d1a8f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d1a8f0"]])

export default __exports__